define('app/config/assetSizes',{
	'100000-9999999999999999': 'Over $100 Billion',
	'75000-100000': '> $75 Billion and < $100 Billion',
	'50000-75000': '> $50 Billion and < $75 Billion',
	'25000-50000': '> $25 Billion and < $50 Billion',
	'10000-25000': '> $10 Billion and < $25 Billion',
	'5000-10000': '> $5 Billion and < $10 Billion',
	'1000-5000': '> $1 Billion and < $5 Billion',
	'750-1000': '> $750 Million and < $1 Billion',
	'500-750': '> $500 Million and < $750 Million',
	'250-500': '> $250 Million and < $500 Million',
	'100-250': '> $100 Million and < $250 Million',
	'50-100': '> $50 Million and < $100 Million',
	'0-50': 'Under $50 Million'
});

